import Bowser from 'bowser'

class BrowserUpdatePopup extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.browser = Bowser.getParser(window.navigator.userAgent)
		this.supportedBrowsersList = JSON.parse(this.dataset.supportedBrowsers)
		this.browserUpdateLink = document.getElementById('browserUpdateLink')

		this.checkSupport()
	}

	getBrowserSupportInfo() {
		const unsatisfiedBrowser = this.supportedBrowsersList.find(
			(supportedBrowser) =>
				this.browser.isBrowser(supportedBrowser.Browser.toLowerCase(), true) &&
				!this.browser.satisfies({
					[supportedBrowser.Browser.toLowerCase()]: `>=${supportedBrowser.Version}`,
				})
		)

		return {
			supported: !unsatisfiedBrowser,
			upgradeLink: unsatisfiedBrowser?.UpgradeLink ?? '',
		}
	}

	checkSupport() {
		const browserSupportInfo = this.getBrowserSupportInfo()

		if (!browserSupportInfo.supported) {
			if (!browserSupportInfo.upgradeLink) {
				this.browserUpdateLink.outerHTML = this.browserUpdateLink.innerText
			}

			this.showPopup(browserSupportInfo.upgradeLink)
		}
	}

	showPopup(upgradeLink) {
		this.classList.add('ready')
		document.documentElement.classList.add('locked-navigation')
		this.browserUpdateLink.href = upgradeLink
		;[...document.body.children]
			.filter((el) => !el.classList.contains('browser-update-popup'))
			.forEach((el) => {
				el.setAttribute('aria-hidden', 'true')
			})
		const _makePageNotTabbable = () => {
			;[...document.querySelectorAll('*:not(.browser-update-popup)')]
				.filter((el) => !el.closest('.browser-update-popup'))
				.forEach((el) => el.setAttribute('tabindex', '-1'))
		}
		_makePageNotTabbable()
		setTimeout(_makePageNotTabbable, 3000)
	}
}

customElements.define('browser-update-popup', BrowserUpdatePopup)
